import React from 'react';
import { Form, Container, Row, Col } from 'react-bootstrap';
import '../../assets/styles/App.css'
import { Navigate } from 'react-router-dom';
import { Formik } from "formik";
import LoginValidator from "../../validators/LoginValidator";
import { loginIn, loginNFC } from "../../actions/authActions";
import { connect } from 'react-redux';
import UIButton from "../utilities/UIButton";
import cookie from "../../utilities/cookie";
import { NFCLogin } from '../NFCLogin';
import { useTranslation } from 'react-i18next';
import { toastError } from '../../actions/formInputAction';

interface Props {
    dispatch: Function;
    isAuthenticated: boolean;
}
const Login: React.FC<Props> = ({ dispatch, isAuthenticated }) => {
    const tenant = cookie.get('tenant');
    const { i18n } = useTranslation();
    // @ts-ignore
    const t = (txt: string) => i18n.t(txt)
    var lastPlatform = cookie.get('last_platform');

    return (isAuthenticated && tenant) ?
        (<Navigate to='/dashboard'></Navigate>)
        : (
            <Container className="mt-5 Login">
                <Row className="justify-content-center">
                    <NFCLogin callback={(data: any) => {
                        if (data !== undefined) {
                            let pf = document.getElementById('formBasicPlatform') as HTMLFormElement;
                            if (pf !== undefined) {
                                if (pf.value === "") {
                                    dispatch(toastError({},'Error', t("login.errors.empty_platform_field")));
                                } else {
                                    lastPlatform = pf.value;
                                    dispatch(loginNFC(data, lastPlatform));
                                }
                            }
                        }
                    }} />
                    <Col md={6}>
                        <h2 className="text-center">Login</h2>
                        <Formik
                            initialValues={{
                                platform: ((lastPlatform !== undefined) ? (lastPlatform as string) : ''),
                                username: '',
                                password: '',
                            }}
                            validationSchema={LoginValidator}
                            onSubmit={values => {
                                dispatch(loginIn(values.username, values.password, values.platform));
                            }}>
                            {({ errors, touched, values, handleSubmit, handleChange, }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3" controlId="formBasicPlatform">
                                        <Form.Label>Platform</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="platform"
                                            placeholder="Enter platform"
                                            value={values.platform}
                                            onChange={handleChange}
                                            isValid={touched.platform && !errors.platform}
                                        />
                                        <Form.Control.Feedback type="invalid" tooltip>
                                            {errors.platform}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicUsername">
                                        <Form.Label>{t('Username')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="username"
                                            placeholder="Enter Username"
                                            value={values.username}
                                            onChange={handleChange}
                                            isValid={touched.username && !errors.username}
                                        />
                                        <Form.Control.Feedback type="invalid" tooltip>
                                            {errors.username}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    {/* Password Field */}
                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>{t('Password')}</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Password"
                                            name="password"
                                            value={values.password}
                                            onChange={handleChange}
                                            isValid={touched.password && !errors.password}
                                        />
                                        <Form.Control.Feedback type="invalid" tooltip>
                                            {errors.password}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    {/* Submit Button */}
                                    <UIButton id='login-button' type="submit" label="Login" variant="primary" />
                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </Container>
        );
}



const mapStateToProps = (state: any) => ({
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Login);
